import classNames from 'classnames'
import './index.scss'
import {useSelector} from 'react-redux'

const NotFound = ({message, icon}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('resource-not-found', {
            dark: isDarkMode
        })}>
            <span className="page-icon">{icon}</span>
            <span className="not-found-text">{message}</span>
        </div>
    )
}

export default NotFound
